var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.conflito
    ? _c(
        "validation-observer",
        { ref: "conflito", attrs: { tag: "div" } },
        [
          _c(
            "el-card",
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-divider", {
                        attrs: {
                          label: "Dados do Conflito",
                          showBorder: true,
                          required: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Número do Processo:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(_vm._s(_vm.conflito.numeroProcesso))
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Município:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.conflito.municipio
                              ? _vm.conflito.municipio.nome
                              : "-"
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Número de Famílias:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(_vm._s(_vm.conflito.numeroFamilias))
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Jurisdição:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(_vm._s(_vm.conflito.jurisdicaoFormatada))
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Data de Cadastro:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(_vm._s(_vm.conflito.dataCriacaoFormatada))
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                    [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("Origem:")
                      ]),
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(_vm._s(_vm.conflito.origemFormatada))
                      ])
                    ]
                  ),
                  _vm.conflito.geometrias && _vm.conflito.geometrias.length > 0
                    ? _c(
                        "el-col",
                        { staticClass: "margin-top", attrs: { span: 24 } },
                        [
                          _c("app-resumo-mapa", {
                            attrs: {
                              idMapa: "id-mapa-localizacao-" + _vm.conflito.id,
                              height: 30,
                              localizacoes: _vm.conflito.geometrias,
                              isVisualizarCadastro: true
                            }
                          }),
                          _c("div", { staticClass: "flex-button" }, [
                            _c(
                              "div",
                              { staticClass: "btn" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadShape(
                                          _vm.conflito.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fal fa-download" }),
                                    _vm._v("  Download do shapefile")
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "top-margin" },
            [
              _c(
                "el-row",
                { staticClass: "marginLeft" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-divider", {
                        attrs: {
                          label: "Responder Solicitação",
                          showBorder: true,
                          required: "required"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          mode: "lazy",
                          rules: "required",
                          name: "Responder Solicitação"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Resposta: ",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { type: "textarea", rows: 4 },
                                    model: {
                                      value: _vm.conflito.resposta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.conflito, "resposta", $$v)
                                      },
                                      expression: "conflito.resposta"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4099454728
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-radios-tramitacao", {
                        attrs: { radios: _vm.radios, isDecisao: true },
                        on: { changeRadio: _vm.changeRadio }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 24 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "default", size: "small" },
                      on: { click: _vm.cancelar }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _c("i", { staticClass: "fa fa-times" }),
                        _c("b", [_vm._v("  Cancelar")])
                      ])
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "success", size: "small" },
                      on: { click: _vm.salvarCadastro }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _c("i", { staticClass: "fa fa-share-square" }),
                        _c("b", [_vm._v("  Enviar")])
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-783a53fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783a53fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/ValidarShapeConflito.vue
// module id = null
// module chunks = 